import React, { useEffect, useMemo, useState } from 'react'
import { AdminHeading } from '../../../../../components/headings'
import { Box, CircularProgress, Grid, styled } from '@mui/material'
import '../../../../../styles/components/_box.scss'
import {
  SearchInputBasic,
  SelectInputObject,
} from '../../../../../components/inputs'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faCircleExclamation,
  faCirclePlus,
} from '@fortawesome/pro-regular-svg-icons'
import { ListTableProspects } from '../../../../../components/tables'
import Api from '../../../../../services/api.service'
import { handlingErrors } from '../../../../../utils'
import { Slide, toast, ToastContainer } from 'react-toastify'
import lightTheme from '../../../../../styles/theme/lightTheme'
import { useNavigate } from 'react-router-dom'
import { BorderButtonPurple } from '../../../../../components/buttons'
import AppPagination from '../../../../../components/paginations'
import { DeleteProfilModal } from '../../../../../components/modals'
import { debounce, normalizeText } from '../../../../../config'
import { ROLE_CANDIDAT } from '../../../../../data'
import { faDownload } from '@fortawesome/pro-solid-svg-icons'

const WrapperButton = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}))

const BlockButton = styled(Box)(({ theme }) => ({
  display: 'flex',
  columnGap: '15px',
  alignItems: 'center',
}))

const ListProspectCandidate = () => {
  let navigate = useNavigate()
  const [prospectsCandidate, setProspectsCandidate] = useState([])
  const [loading, setLoading] = useState(false)
  const [id, setId] = useState(null)
  //const [openCard, setOpenCard] = useState('')
  const [role, setRole] = useState(null)
  const [searchQuery, setSearchQuery] = useState(
    sessionStorage.getItem('prospectSearchQuery') || ''
  )
  const [loadingDelete, setLoadingDelete] = useState(false)
  const [loadingExport, setLoadingExport] = useState(false)
  const [userId, setUserId] = useState()
  const [openDeleteModal, setOpenDeleteModal] = useState(false)
  const handleCloseDeleteModal = () => setOpenDeleteModal(false)
  const handleConfirmDeleteModal = () => confirmRemoveProfil()
  const [page, setPage] = useState(
    sessionStorage.getItem('pageProspectCandidat')
      ? parseInt(sessionStorage.getItem('pageProspectCandidat'))
      : 1
  )
  const [count, setCount] = useState(0)
  const [filter, setFilter] = useState([
    { id: 5, titre: 'ID', filtre: 'id' },
    { id: 0, titre: 'Nom, Prenom, Email ou Téléphone', filtre: 'search' },
    { id: 1, titre: 'Poste', filtre: 'candidat.poste.titreNormalized' },
    { id: 2, titre: 'Compétences techniques', filtre: 'candidat.competences' },
    { id: 3, titre: 'Softskills', filtre: 'candidat.softskils' },
    { id: 4, titre: 'Valeurs', filtre: 'candidat.valeurs' },
  ])
  const [filterSelect, setFilterSelect] = useState(() => {
    const savedFilterId = sessionStorage.getItem('prospectFilterSelect')
    if (savedFilterId) {
      const savedFilter = filter.find((f) => f.id === parseInt(savedFilterId))
      return savedFilter || filter[0]
    }
    return filter[0]
  })

  const handleSearchChange = debounce((event) => {
    const { value } = event.target
    let searchValue = value

    if (filterSelect.id === 1) {
      searchValue = normalizeText(searchValue)
    }

    setSearchQuery(searchValue)
    sessionStorage.setItem('prospectSearchQuery', searchValue)
  }, 800)

  useEffect(() => {
    // Clear other components' states when this component mounts
    sessionStorage.removeItem('prospectCompanySearchQuery')
    sessionStorage.removeItem('candidateSearchQuery')
    sessionStorage.removeItem('candidateFilterSelect')
    sessionStorage.removeItem('companySearchQuery')
    sessionStorage.removeItem('besoinsSearchQuery')
    sessionStorage.removeItem('besoinsFilterSelect')

    getProspectCandidate(page)
  }, [])

  useEffect(() => {
    getProspectCandidate(page)
  }, [id, role, searchQuery])

  useEffect(() => {
    if (searchQuery !== '') getProspectCandidate(page)
  }, [filterSelect])

  const handleFilterSelect = (event) => {
    const inputValue = event.target.value
    setFilterSelect(inputValue)
    sessionStorage.setItem('prospectFilterSelect', inputValue.id)
  }

  const handleRemoveProfil = (idUser) => {
    setOpenDeleteModal(true)
    setUserId(idUser)
  }

  const confirmRemoveProfil = async () => {
    setLoadingDelete(true)
    try {
      const result = await Api.user.delete(userId)

      const res = handlingErrors(result)

      if (res.status === 401) {
        toast.error('Votre session à expiré, merci de vous reconnecter.', {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
          icon: ({ theme, type }) => (
            <FontAwesomeIcon
              icon={faCircleExclamation}
              fontSize={25}
              color={lightTheme.palette.error.main}
            />
          ),
        })
      }

      if (res.ok) {
        setOpenDeleteModal(false)
        const indexCandidate = prospectsCandidate.findIndex(
          (candidate) => candidate.id === userId
        )
        if (indexCandidate > -1) {
          prospectsCandidate.splice(indexCandidate, 1)
        }
        setProspectsCandidate(prospectsCandidate)
        setLoadingDelete(false)
      }

      if (res.status === 0) {
        getProspectCandidate(page)
        setLoadingDelete(false)
        toast.error(
          "Quelque chose s'est mal passé ! Merci d'essayer plus tard.",
          {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
            icon: ({ theme, type }) => (
              <FontAwesomeIcon
                icon={faCircleExclamation}
                fontSize={25}
                color={lightTheme.palette.error.main}
              />
            ),
          }
        )
      }
    } catch (error) {
      getProspectCandidate(page)
      toast.error(
        "Quelque chose s'est mal passé ! Merci d'essayer plus tard.",
        {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
          icon: ({ theme, type }) => (
            <FontAwesomeIcon
              icon={faCircleExclamation}
              fontSize={25}
              color={lightTheme.palette.error.main}
            />
          ),
        }
      )
    }
  }

  const handlePageChange = (event, page) => {
    setPage(page)
    getProspectCandidate(page)
    sessionStorage.setItem('pageProspectCandidat', page)
  }
  const getProspectCandidate = async (page) => {
    setLoading(true)
    setRole(ROLE_CANDIDAT)

    let payload = {
      search: searchQuery,
    }
    payload = Object.entries(payload).reduce(
      (a, [k, v]) => (v ? ((a[k] = v), a) : a),
      {}
    )
    if (filterSelect.id !== 0) {
      payload = {
        [filterSelect.filtre]: searchQuery,
      }
    }

    if (filterSelect.id === 1) {
      payload = {
        [filterSelect.filtre]: normalizeText(searchQuery),
      }
    }

    try {
      const result = await Api.user.listWithPaginationAndFilterAndOrderByDate({
        role: ROLE_CANDIDAT,
        status: ['classic', 'proposition_inscription'],
        page: page,
        ...payload,
      })

      const res = handlingErrors(result)

      if (res.status === 401) {
        toast.error('Votre session à expiré, merci de vous reconnecter.', {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
          icon: ({ theme, type }) => (
            <FontAwesomeIcon
              icon={faCircleExclamation}
              fontSize={25}
              color={lightTheme.palette.error.main}
            />
          ),
        })
      }

      if (res.ok) {
        setProspectsCandidate(res.data['hydra:member'])
        setCount(res.data['hydra:totalItems'])
        /* const sort = res.data.sort(( a, b) => ( a.date < b.date ? 1 : -1)); */
      }

      if (res.status === 0) {
        toast.error(
          "Quelque chose s'est mal passé ! Merci d'essayer plus tard.",
          {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
            icon: ({ theme, type }) => (
              <FontAwesomeIcon
                icon={faCircleExclamation}
                fontSize={25}
                color={lightTheme.palette.error.main}
              />
            ),
          }
        )
      }
    } catch (error) {
      toast.error(
        "Quelque chose s'est mal passé ! Merci d'essayer plus tard.",
        {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
          icon: ({ theme, type }) => (
            <FontAwesomeIcon
              icon={faCircleExclamation}
              fontSize={25}
              color={lightTheme.palette.error.main}
            />
          ),
        }
      )
    }
    setLoading(false)
  }

  const handleClickToProfil = (userId) => {
    // Save current state before navigation
    sessionStorage.setItem('prospectSearchQuery', searchQuery)
    sessionStorage.setItem('prospectFilterSelect', filterSelect.id)
    navigate(`/admin/gestion-prospect/profil-prospect-candidat/${userId}`)
  }

  const exportList = async (type) => {
    setLoadingExport(true)
    try {
      const result = await Api.user.exportList(type)

      const res = handlingErrors(result)

      if (res.status === 401) {
        toast.error('Votre session à expiré, merci de vous reconnecter.', {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
          icon: ({ theme, type }) => (
            <FontAwesomeIcon
              icon={faCircleExclamation}
              fontSize={25}
              color={lightTheme.palette.error.main}
            />
          ),
        })
      }

      if (res.ok) {
        const blobUrl = window.URL.createObjectURL(new Blob([res.data]))

        // Create a link element
        const link = document.createElement('a')

        // Set the link's href to the Blob URL
        link.href = blobUrl

        // Set the download attribute with the desired file name
        link.download = 'candidats_' + type + '_data.csv'

        // Append the link to the document
        document.body.appendChild(link)

        // Trigger a click on the link to start the download
        link.click()

        // Remove the link from the document
        document.body.removeChild(link)
        setLoadingExport(false)
      }

      if (res.status === 0) {
        setLoadingExport(false)
        toast.error(
          "Quelque chose s'est mal passé ! Merci d'essayer plus tard.",
          {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
            icon: ({ theme, type }) => (
              <FontAwesomeIcon
                icon={faCircleExclamation}
                fontSize={25}
                color={lightTheme.palette.error.main}
              />
            ),
          }
        )
      }
    } catch (error) {
      toast.error(
        "Quelque chose s'est mal passé ! Merci d'essayer plus tard.",
        {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
          icon: ({ theme, type }) => (
            <FontAwesomeIcon
              icon={faCircleExclamation}
              fontSize={25}
              color={lightTheme.palette.error.main}
            />
          ),
        }
      )
    }
  }

  return (
    <>
      <div style={{ width: '100%' }}>
        <AdminHeading displayIconReturn={'none'}>
          Liste des prospects candidats
        </AdminHeading>
        <Box
          className={'BoxContainer'}
          sx={{
            padding: '30px',
            display: 'flex',
            flexDirection: 'column',
            rowGap: { xs: '30px', sm: '55px', lg: '70px' },
          }}
        >
          <WrapperButton sx={{ columnGap: '15px' }}>
            <Grid item>
              <SearchInputBasic onChange={handleSearchChange} />
            </Grid>
            <Grid item>
              <SelectInputObject
                items={filter}
                value={filterSelect}
                handleChange={handleFilterSelect}
              />
            </Grid>
            <Grid item>
              <BlockButton>
                <BorderButtonPurple
                  displayText={{ xs: 'none', sm: 'block' }}
                  icon={
                    loadingExport ? (
                      <CircularProgress size={25} />
                    ) : (
                      <FontAwesomeIcon icon={faDownload} fontSize={15} />
                    )
                  }
                  handleClick={() => exportList('prospect')}
                >
                  Exporter la liste
                </BorderButtonPurple>
              </BlockButton>
            </Grid>
            <Grid item>
              <BlockButton>
                <BorderButtonPurple
                  width={{ xs: 45, sm: 230, lg: 265 }}
                  displayText={{ xs: 'none', sm: 'block' }}
                  icon={<FontAwesomeIcon icon={faCirclePlus} fontSize={15} />}
                  handleClick={() =>
                    navigate('/admin/gestion-client/ajouter-client-candidat')
                  }
                >
                  Ajouter un candidat
                </BorderButtonPurple>
              </BlockButton>
            </Grid>
          </WrapperButton>

          <ListTableProspects
            type={'candidat'}
            items={prospectsCandidate}
            setId={setId}
            loading={loading}
            handleClick={handleClickToProfil}
            handleRemove={handleRemoveProfil}
          />

          <AppPagination
            handlePageChange={handlePageChange}
            count={count}
            page={page}
          />
        </Box>
      </div>

      <DeleteProfilModal
        open={openDeleteModal}
        onClose={handleCloseDeleteModal}
        onConfirm={handleConfirmDeleteModal}
        loading={loadingDelete}
      />

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        closeButton={false}
        transition={Slide}
        className={'toast'}
      />
    </>
  )
}

export default ListProspectCandidate
